var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRiverHeight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RiverHeight2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#2B6E72",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,37.5 C4,37.5 5,27.5 9,27.5 C8,32 12,37.5 16,37.5 C20,37.5 21,27.5 25,27.5 C24,32 28,37.5 32,37.5 C36,37.5 36,27.5 40,27.5 C39,32 43.2,37.5 48,37.5",
    id: "Line",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line-3",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "13 17.9097095 12.0719714 19.7315369 9.45724483 18.5748265 13.1926367 12.8278881 14.5 11 15.8073633 12.8278881 19.5427552 18.5748265 16.9280286 19.7315369 16 17.9097095 16 25.9895802 16 35.8203122 16 37 13 37 13 35.8203122 13 25.9895802"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiverHeight);
export default __webpack_public_path__ + "static/media/RiverHeight.9ac041724fb8a4f3a91032bfc65fb2aa.svg";
export { ForwardRef as ReactComponent };